export function hasStaffKeyName(config = {}) {
  return config.keyNameInput === true || config.keyNameInput?.enabled === true;
}
export function staffKeyNamePoints(config = {}) {
  const max = Math.max(0, Number(config.points) || 0);
  const raw = Number(config.gradingPoints?.keyName ?? 0.5);
  return Math.min(max, Math.max(0, Number.isFinite(raw) ? raw : 0.5));
}
function parseKey(value) {
  const text = String(value ?? '').trim().replace(/\u0231|♭/g,'b').replace(/♯/g,'#')
    .replace(/\bflat\b/gi,'b').replace(/\bsharp\b/gi,'#').replace(/♮/g,'')
    .replace(/\s+/g,'');
  const match = text.match(/^([a-g])([#b]{0,2})(major|minor|maj|min)?$/i);
  if (!match) return null;
  return {tonic:match[1].toUpperCase()+match[2].toLowerCase(), mode:match[3]?.toLowerCase().replace(/^maj$/, 'major').replace(/^min$/, 'minor')};
}
export function staffKeyNamesMatch(received, expected, suffix = 'Major') {
  const got = parseKey(received), key = parseKey(expected);
  if (!got || !key || got.tonic !== key.tonic) return false;
  const suffixMode = /^(major|maj)$/i.test(suffix) ? 'major' : /^(minor|min)$/i.test(suffix) ? 'minor' : null;
  const expectedMode = key.mode || suffixMode;
  return !got.mode || !expectedMode || got.mode === expectedMode;
}
